// extracted by mini-css-extract-plugin
export default {"Box":"get-sub-issues-block-module__Box--DvwBt","Box_1":"get-sub-issues-block-module__Box_1--rxPka"};